"use client"

import { useUserOwnedNft } from "@/app/nft/hooks/use-user-owned-nft"
import { isExternalListing } from "@anaconda/core/nft/listing-source"
import type { Nft } from "@anaconda/core/nft/types"
import { reatomComponent } from "@reatom/react"
import { ListingDialogReatom as ListingDialog } from "../../listing-dialog/listing-dialog.reatom"
import { BuyButtonReatom as BuyButton } from "./buy.reatom"
import { CancelButtonReatom as CancelButton } from "./cancel.reatom"
import { MakeOfferButton } from "./make-offer"
import { NftSellButton } from "./nft-sell-button"

interface Props {
  nft: Nft
}

export const PrimaryAction = reatomComponent<Props>(({ nft }) => {
  const { userOwnedNft } = useUserOwnedNft(nft)

  if (!userOwnedNft) {
    if (nft.price) return <BuyButton nft={nft} className="flex-grow" />

    // Not listed: offering is the only thing a visitor can do here.
    return <MakeOfferButton nft={nft} className="flex-grow" />
  }

  // Already listed (ours or ME) — no second listing CTA
  return !nft.price ? <ListingDialog nft={nft} /> : null
}, "PrimaryAction")

export const SecondaryAction = reatomComponent<Props>(({ nft }) => {
  const { userOwnedNft } = useUserOwnedNft(nft)

  // @todo add skeleton
  // if (isConnecting) return <OrderWidgetActionSkeleton />

  // Visitors get the offer CTA in the secondary slot when the item is listed,
  // so Buy Now keeps the primary one.
  if (!userOwnedNft) {
    return nft.price ? <MakeOfferButton nft={nft} /> : null
  }

  // External listings are display-only: cancel/sell live on their marketplace
  if (isExternalListing(nft.listingSource)) {
    return null
  }

  return (
    <>
      {nft.price && <CancelButton nft={nft} />}
      <NftSellButton nft={nft} />
    </>
  )
}, "SecondaryAction")
